const allTestimonials = [
  {
    quote:
      "Blue Moon is honestly the best salon I've visited in Muscat — and I've tried quite a few! The Gold Facial left my skin absolutely glowing for weeks. The staff are warm, professional, and genuinely care about getting it right.",
    author: "Sarah Mitchell",
    flag: "🇬🇧",
    origin: "British expat, Muscat",
    rating: 5,
    service: "Gold Facial",
    dir: "ltr" as const,
    image: "https://public.readdy.ai/ai/img_res/5d92d6ddd68630d18c590ba9fadfa86d.jpg",
  },
  {
    quote:
      "صالون القمر الأزرق هو الأفضل في مسقط بلا منازع! أزوره منذ أكثر من سنتين وكل مرة أخرج منه وأنا أشعر بالجمال والثقة. جلسة الوجه الذهبية غيّرت بشرتي بشكل كامل.",
    author: "فاطمة البلوشي",
    authorLatin: "Fatima Al Balushi",
    flag: "🇴🇲",
    origin: "الخوض، مسقط",
    rating: 5,
    service: "جلسة الوجه الذهبية",
    dir: "rtl" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20cheerful%20middle%20eastern%20woman%20in%20her%2020s%20with%20warm%20bright%20smile%2C%20hijab%20style%20modern%20fashion%2C%20golden%20light%20photography%2C%20elegant%20beauty%2C%20soft%20focus%20background%2C%20studio%20portrait&width=400&height=400&seq=bm_ar_mix1&orientation=squarish",
  },
  {
    quote:
      "I came in for a keratin treatment before a big work trip and WOW — my hair has never felt this silky and manageable! The stylist really took her time. Absolutely worth every penny.",
    author: "Priya Sharma",
    flag: "🇮🇳",
    origin: "Indian expat, Al Koudh",
    rating: 5,
    service: "Keratin Treatment",
    dir: "ltr" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20beautiful%20young%20indian%20woman%20with%20healthy%20shiny%20hair%2C%20warm%20confident%20smile%2C%20natural%20studio%20lighting%2C%20elegant%20appearance%2C%20lifestyle%20photography%20clean%20background&width=400&height=400&seq=bm_en002&orientation=squarish",
  },
  {
    quote:
      "جربت الكثير من الصالونات في مسقط لكن لا يوجد مثل القمر الأزرق. الاهتمام بالتفاصيل والدقة في العمل لا مثيل لهم. تصفيف الشعر والصبغة جاءت تماماً كما تخيلت.",
    author: "مريم الزدجالي",
    authorLatin: "Maryam Al Zadjali",
    flag: "🇴🇲",
    origin: "مسقط، عُمان",
    rating: 5,
    service: "صبغ وتصفيف الشعر",
    dir: "rtl" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20sophisticated%20arab%20woman%20in%20her%2030s%20with%20stylish%20dark%20wavy%20hair%2C%20elegant%20necklace%2C%20minimal%20makeup%2C%20warm%20golden%20hour%20natural%20light%2C%20refined%20beauty%20photography%2C%20bokeh%20background&width=400&height=400&seq=bm_ar_mix2&orientation=squarish",
  },
  {
    quote:
      "The nail art team here is incredibly skilled! I asked for a custom design for my wedding and they nailed it — literally. Very hygienic, relaxing atmosphere. I'll be back every month!",
    author: "Deepa Krishnan",
    flag: "🇮🇳",
    origin: "Indian expat, Muscat",
    rating: 5,
    service: "Bridal Nail Art",
    dir: "ltr" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20young%20happy%20south%20indian%20woman%20with%20beautiful%20smile%2C%20warm%20glowing%20skin%2C%20casual%20elegant%20style%2C%20professional%20headshot%20photography%2C%20soft%20warm%20light%20background&width=400&height=400&seq=bm_en003&orientation=squarish",
  },
  {
    quote:
      "طلبت منهم مكياج عرائس لأختي وكانت النتيجة مذهلة! الفنانة فهمت الطلب بدقة وأبدعت في كل التفاصيل. أختي كانت أجمل عروس في الحفل.",
    author: "نورة الحارثي",
    authorLatin: "Noura Al Harthi",
    flag: "🇴🇲",
    origin: "الخوض، سلطنة عُمان",
    rating: 5,
    service: "مكياج العرائس",
    dir: "rtl" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20young%20omani%20woman%20with%20glowing%20bridal%20makeup%20look%2C%20elegant%20pearl%20accessories%2C%20radiant%20happy%20expression%2C%20pink%20and%20gold%20tones%2C%20soft%20luxurious%20studio%20light%2C%20beauty%20photography&width=400&height=400&seq=bm_ar_mix3&orientation=squarish",
  },
  {
    quote:
      "I booked a bridal makeup session here for my sister's wedding and the result was breathtaking. The artist understood exactly what we wanted — classic yet modern. Every single guest complimented her look.",
    author: "Emma Thompson",
    flag: "🇬🇧",
    origin: "British expat, Muscat",
    rating: 5,
    service: "Bridal Makeup",
    dir: "ltr" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20elegant%20British%20woman%20with%20beautiful%20natural%20makeup%2C%20soft%20blonde%20hair%2C%20warm%20studio%20photography%2C%20confident%20friendly%20smile%2C%20clean%20light%20background&width=400&height=400&seq=bm_en004&orientation=squarish",
  },
  {
    quote:
      "المساج في صالون القمر الأزرق تجربة لا تُنسى! كنت أعاني من آلام الظهر والتوتر لفترة طويلة وبعد جلسة مساج الحجر الساخن شعرت وكأنني ولدت من جديد.",
    author: "حصة الشبلية",
    authorLatin: "Hissa Al Shiblia",
    flag: "🇴🇲",
    origin: "مسقط، عُمان",
    rating: 5,
    service: "مساج الحجر الساخن",
    dir: "rtl" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20serene%20mature%20arab%20woman%20with%20calm%20peaceful%20expression%2C%20short%20layered%20dark%20hair%20with%20highlights%2C%20elegant%20minimal%20style%2C%20soft%20warm%20spa%20lighting%2C%20relaxed%20confident%20beauty%2C%20clean%20cream%20background&width=400&height=400&seq=bm_ar_mix4&orientation=squarish",
  },
  {
    quote:
      "I've had massages in many luxury spas — and Blue Moon is right up there. The hot stone massage here is genuinely outstanding. So relaxing, so professional. A must-try in Muscat.",
    author: "Anjali Menon",
    flag: "🇮🇳",
    origin: "Indian expat, Muscat",
    rating: 5,
    service: "Hot Stone Massage",
    dir: "ltr" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20graceful%20indian%20woman%20with%20serene%20happy%20expression%2C%20dark%20long%20hair%2C%20soft%20natural%20lighting%2C%20elegant%20beauty%20photography%2C%20minimal%20clean%20background&width=400&height=400&seq=bm_en005&orientation=squarish",
  },
  {
    quote:
      "صالون القمر الأزرق ليس مجرد صالون بل هو تجربة جمالية متكاملة. الأظافر، الشعر، البشرة — كل شيء على أعلى مستوى. الفريق ودود ومحترف.",
    author: "شيخة المقبالية",
    authorLatin: "Shaikha Al Maqbalia",
    flag: "🇴🇲",
    origin: "الخوض 7، مسقط",
    rating: 5,
    service: "باقة عناية متكاملة",
    dir: "rtl" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20confident%20elegant%20arab%20businesswoman%20in%20her%2030s%2C%20stylish%20modern%20outfit%2C%20curly%20dark%20hair%2C%20bold%20lip%20colour%2C%20professional%20headshot%20photography%2C%20warm%20studio%20background&width=400&height=400&seq=bm_ar_mix5&orientation=squarish",
  },
  {
    quote:
      "I always leave Blue Moon looking and feeling like a completely new person. The color specialist here is an absolute genius — I get compliments on my highlights everywhere I go in Muscat.",
    author: "Jessica Williams",
    flag: "🇺🇸",
    origin: "American expat, Al Koudh",
    rating: 5,
    service: "Hair Highlights",
    dir: "ltr" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20beautiful%20american%20woman%20with%20gorgeous%20highlighted%20hair%2C%20bright%20confident%20smile%2C%20warm%20natural%20light%2C%20casual%20elegant%20fashion%2C%20clean%20studio%20background&width=400&height=400&seq=bm_en006&orientation=squarish",
  },
  {
    quote:
      "خدمة الكيراتين في القمر الأزرق أفضل ما جربت في سلطنة عُمان. شعري كان يعاني من التجعد بسبب الرطوبة والآن أصبح ناعماً ولامعاً بشكل رائع.",
    author: "ريا النبهانية",
    authorLatin: "Raya Al Nabhania",
    flag: "🇴🇲",
    origin: "مسقط، سلطنة عُمان",
    rating: 5,
    service: "علاج الكيراتين",
    dir: "rtl" as const,
    image: "https://readdy.ai/api/search-image?query=portrait%20of%20vibrant%20young%20omani%20woman%20with%20long%20straight%20shiny%20black%20hair%20blowing%20gently%2C%20joyful%20bright%20smile%2C%20casual%20chic%20fashion%2C%20outdoor%20natural%20golden%20light%2C%20fresh%20beauty%20aesthetic&width=400&height=400&seq=bm_ar_mix6&orientation=squarish",
  },
];

function StarRow({ count = 5 }: { count?: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#c6a864] text-sm"></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="py-16 sm:py-24 bg-[#f8f7f4] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Header */}
        <div className="text-center mb-10 sm:mb-14">
          <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">
            Real Stories · تجارب حقيقية
          </p>
          <h2
            className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            What Our Clients{" "}
            <span className="italic text-[#c6a864]">Say</span>
          </h2>
          <p className="text-gray-400 text-sm mt-2 max-w-md mx-auto">
            Trusted by clients from across Oman and the world — Omani, expat, and visitors alike.
          </p>
        </div>

        {/* Mixed Reviews Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {allTestimonials.map((t) => (
            <div
              key={t.author}
              dir={t.dir}
              className="bg-white p-6 sm:p-7 flex flex-col group hover:border-[#c6a864] border border-transparent transition-colors duration-300"
            >
              {/* Top row */}
              <div className="flex items-start gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.image}
                    alt={"authorLatin" in t ? (t as { authorLatin: string }).authorLatin : t.author}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="flex items-center gap-1.5">
                    <p
                      className="text-[#1a2744] text-sm font-semibold leading-tight"
                      style={t.dir === "rtl" ? { fontFamily: "'Noto Naskh Arabic', serif" } : undefined}
                    >
                      {t.author}
                    </p>
                    <span className="text-base">{t.flag}</span>
                  </div>
                  {"authorLatin" in t && (
                    <p className="text-gray-400 text-xs mt-0.5 font-light" dir="ltr">
                      {(t as { authorLatin: string }).authorLatin}
                    </p>
                  )}
                  <p
                    className="text-gray-400 text-xs mt-0.5"
                    style={t.dir === "rtl" ? { fontFamily: "'Noto Naskh Arabic', serif" } : undefined}
                  >
                    {t.origin}
                  </p>
                  <StarRow count={t.rating} />
                </div>
              </div>

              {/* Service badge */}
              <div className="mb-3">
                <span
                  className="inline-flex items-center gap-1 bg-[#f4f2ec] text-[#c6a864] text-xs px-2.5 py-1"
                  style={t.dir === "rtl" ? { fontFamily: "'Noto Naskh Arabic', serif" } : undefined}
                >
                  <i className="ri-scissors-2-line text-xs"></i>
                  {t.service}
                </span>
              </div>

              {/* Quote */}
              <div className="flex-1">
                <i
                  className={`${t.dir === "rtl" ? "ri-double-quotes-r" : "ri-double-quotes-l"} text-[#c6a864] text-2xl leading-none block mb-2`}
                ></i>
                <p
                  className="text-gray-600 text-sm leading-relaxed italic"
                  style={t.dir === "rtl" ? { fontFamily: "'Noto Naskh Arabic', serif", lineHeight: "1.9", fontStyle: "normal" } : undefined}
                >
                  {t.quote}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom stats bar */}
        <div className="mt-12 sm:mt-16 grid grid-cols-3 gap-4 sm:gap-8 border-t border-[#e5e0d5] pt-10">
          {[
            { num: "1,200+", label: "Happy Clients", labelAr: "عميلة سعيدة" },
            { num: "4.9★", label: "Google Rating", labelAr: "تقييم جوجل" },
            { num: "5 Years", label: "Serving Muscat", labelAr: "نخدم مسقط" },
          ].map((stat) => (
            <div key={stat.num} className="text-center">
              <p
                className="text-[#1a2744] text-2xl sm:text-3xl font-light mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {stat.num}
              </p>
              <p className="text-gray-500 text-xs uppercase tracking-widest">{stat.label}</p>
              <p
                className="text-gray-400 text-xs mt-0.5"
                style={{ fontFamily: "'Noto Naskh Arabic', serif" }}
              >
                {stat.labelAr}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
